import {
  Button,
  ListItemButton as MuiListItemButton,
  listItemTextClasses,
} from "@mui/material"
import { alpha, styled } from "@mui/material/styles"

import type {
  AccordionButtonProps,
  SidebarListStyleButtonProps,
} from "types/styled.types"

export const SidebarListStyleButton = styled(MuiListItemButton, {
  shouldForwardProp: (prop) => prop !== "open",
})<SidebarListStyleButtonProps>(({ theme, open }) => ({
  color: theme.palette.grey[300],
  paddingLeft: open ? "1rem" : 0,
  ...(!open && {
    paddingRight: 0,
  }),
  borderRadius: 1,
  justifyContent: open ? "flex-start" : "center",
  textAlign: "left",
  textTransform: "none",
  width: "100%",
  "&:hover": {
    backgroundColor: alpha(theme.palette.grey[100], 0.05),
  },
  // The bar marks the current page, so its fill can stay a light gray.
  "&.Mui-selected": {
    color: theme.palette.grey[100],
    backgroundColor: alpha(theme.palette.grey[100], 0.06),
    [`& .${listItemTextClasses.primary}`]: {
      fontWeight: theme.typography.fontWeightBold,
    },
    "&:hover": {
      backgroundColor: alpha(theme.palette.grey[100], 0.1),
    },
    "&.Mui-focusVisible": {
      backgroundColor: alpha(theme.palette.grey[100], 0.14),
    },
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: 6,
      bottom: 6,
      width: 3,
      borderRadius: "0 3px 3px 0",
      backgroundColor: theme.palette.primary.main,
    },
  },
}))

export const TabButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "variant",
})<AccordionButtonProps>(({ theme, variant }) => ({
  color: theme.palette.text.primary,
  borderColor: theme.palette.neutral[400],
  backgroundColor: variant === "contained" ? theme.palette.neutral[300] : "transparent",
  "&:hover": {
    backgroundColor: theme.palette.neutral[400],
    borderColor: theme.palette.neutral[400],
  },
}))
